
export function toColorString(color) {
    const r = (color >> 16) | 0;
    const g = ((color >> 8) & 255) | 0;
    const b = (color & 255) | 0;
    return `rgb(${r},${g},${b})`;
}

export function adjustColor(color, value) {
    return (((color & 255) + value) | ((((color >> 8) & 255) + value) << 8)) | (((color >> 16) + value) << 16);
}

export function fill(context, color, left, top, width, height) {
    context.fillStyle = toColorString(color);
    context.fillRect(left, top, width, height);
}

export function clearCanvas(context) {
    fill(context, 0, -1, -1, context.canvas.width + 2, context.canvas.height + 2);
}

export function fillText(context, text, x, y) {
    context.textAlign = "start";
    context.fillStyle = "#e0e0e0";
    context.fillText(text, x, y);
}

